import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { validateInn } from '@alfa-bank/site-form-helpers/validation/inn';
import { validateOgrn } from '@alfa-bank/site-form-helpers/validation/ogrn';
import { validateEmail } from '@alfa-bank/site-form-helpers/validation/email';
import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';
import { validateAlfaPhone } from '@alfa-bank/site-form-helpers/validation/alfa-phone';

import type { IFieldValidators } from '../../components/input-field/models';

import { validateFioValue, validateFioOneFieldValue } from './fio';
import { validateCity } from './city';
import { validateFioEmptyValue } from './fio-empty';
import { validateKpp } from './kpp';
import { validateBirthdate } from './birthdate';
import { validatePassportDate } from './passport-date';
import { validatePassport } from './passport';
import { validateAddress } from './address';
import { validateDeliveryCity } from './delivery-city';
import { validatePassportIssueAuthorityCode } from './passport-issue-authority-code';
import { validatePassportNumber } from './passport-number';
import { validatePassportSeries } from './passport-series';

const EMPTY_MESSAGE = 'Поле обязательно для заполнения';

// Требования к валидации http://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=551651342
export const getMaxLengthErrorMessage = (maxLength: number) =>
    `Количество символов не может быть больше ${maxLength}`;

export const getMaxLengthValidator =
    (maxLength: number, getError = getMaxLengthErrorMessage) =>
    (value?: string) =>
        value && value.length > maxLength ? getError(maxLength) : undefined;

export const validateEmailField = () =>
    composeValidators(getMaxLengthValidator(35), validateEmail());

export const validatePhoneNotEmpty =
    (message = EMPTY_MESSAGE) =>
    (value?: TValidatorValue) =>
        validate(getNumbersFromStr(value).length > 1, message);

export const validatePhone = () => composeValidators(validatePhoneNotEmpty(), validateAlfaPhone());

export const validateFio = () =>
    composeValidators(validateNotEmpty(), getMaxLengthValidator(105), validateFioValue);

export const validateFioEmpty = () => composeValidators(validateFioEmptyValue);

export const validateFioOneField = () =>
    composeValidators(validateNotEmpty(), getMaxLengthValidator(105), validateFioOneFieldValue);

export const fieldValidators: IFieldValidators = {
    default: () => '',
    phone: validatePhone(),
    required: validateNotEmpty(),
    inn: validateInn(),
    kpp: validateKpp(),
    ogrn: validateOgrn(),
    email: validateEmailField(),
    fio: validateFio(),
    fioEmpty: validateFioEmpty(),
    fioOneField: validateFioOneField(),
    companyName: getMaxLengthValidator(255),
    city: validateCity(),
    deliveryCity: validateDeliveryCity(),
    address: validateAddress(),
    birthdate: validateBirthdate(),
    passportDate: validatePassportDate(),
    passport: validatePassport(),
    passportSeries: validatePassportSeries,
    passportNumber: validatePassportNumber,
    passportIssueAuthorityCode: validatePassportIssueAuthorityCode,
};

export * from './kpp';
